export const departmentOptions = [
  { value: "", label: "Select a department" },
  { value: "General Medicine", label: "General Medicine" },
  { value: "Surgery", label: "Surgery" },
  {
    value: "Obstetrics and Gynaecology (O & G)",
    label: "Obstetrics and Gynaecology (O & G)",
  },
  { value: "Pediatrics", label: "Pediatrics" },
  { value: "Radiology/Imaging", label: "Radiology/Imaging" },
  { value: "Pharmacy", label: "Pharmacy" },
  { value: "Labortory Services", label: "Labortory Services" },
  {
    value: "Emergency Department (A & E)",
    label: "Emergency Department (A & E)",
  },
  { value: "Internal Medicine", label: "Internal Medicine" },

  { value: "Intensive Care Unit (ICU)", label: "Intensive Care Unit (ICU)" },
  { value: "Anesthesia", label: "Anesthesia" },

  { value: "Orthopedics", label: "Orthopedics" },
  { value: "Cardiology", label: "Cardiology" },

  {
    value: "Physiotheraphy/Rehabilitation",
    label: "Physiotheraphy/Rehabilitation",
  },
  { value: "Dental Care", label: "Dental Care" },
  { value: "Ophthalmology (Eye Care)", label: "Ophthalmology (Eye Care)" },
  {
    value: "Ear, Nose, and Throat (ENT)",
    label: "Ear, Nose, and Throat (ENT)",
  },
  { value: "Dermatology", label: "Dermatology" },
  { value: "Urology", label: "Urology" },
  { value: "Oncology", label: "Oncology" },
  { value: "Mental Health/Psychiatry", label: "Mental Health/Psychiatry" },
  {
    value: "Dietary and Nutrition Services",
    label: "Dietary and Nutrition Services",
  },
  { value: "Administration and Billing", label: "Administration and Billing" },
  { value: "Infection Control", label: "Infection Control" },
  {
    value: "Outpatient Department (OPD)",
    label: "Outpatient Department (OPD)",
  },
  { value: "Nephrology/Dialysis Unit", label: "Nephrology/Dialysis Unit" },
  { value: "Geriatrics", label: "Geriatrics" },
  {
    value: "Family Planning and Reproductive Health",
    label: "Family Planning and Reproductive Health",
  },
  {
    value: "Public Health/Preventive Care",
    label: "Public Health/Preventive Care",
  },
  { value: "Other", label: "Other ()" },
];

export const medicType = [
  { value: "", label: "Select a Medic type" },
  { value: "Doctors", label: "Doctors" },
  { value: "Nurses", label: "Nurses" },
  { value: "Midwife", label: "Midwife" },
  { value: "Nurses/Midwife", label: "Nurses/Midwife" },
  { value: "Medical Doctor", label: "Medical Doctor" },
  {
    value: "Local Doctor",
    label: "Local Doctor",
  },
];

export const speciality = [
  { value: "", label: "Select Specialty" },
  {
    value: "Obstetricis and Gynaecology",
    label: "Obstetricis and Gynaecology",
  },
  { value: "Cardiology", label: "Cardiology" },
  { value: "Endocrinology", label: "Endocrinology" },
  { value: "Gastroenterology", label: "Gastroenterology" },
  { value: "Hematology", label: "Hematology" },
  { value: "Infectious Disease", label: "Infectious Disease" },
  { value: "Nephrology", label: "Nephrology" },
  { value: "Oncology", label: "Oncology" },
  { value: "Pulmonology", label: "Pulmonology" },
  { value: "Rheumatology", label: "Rheumatology" },
  { value: "General Surgery", label: "General Surgery" },
  {
    value: "Cardiothoracic Surgery",
    label: "Cardiothoracic Surgery",
  },
  { value: "Neurosurgery", label: "Neurosurgery" },
  { value: "Orthopedic Surgery", label: "Orthopedic Surgery" },
  { value: "Ophthalmology", label: "Ophthalmology" },
  {
    value: "Otolaryngolory (ENT)",
    label: "Otolaryngolory (ENT)",
  },
  { value: "Plastic Surgery", label: "Plastic Surgery" },
  { value: "Vascular Surgery", label: "Vascular Surgery" },
  { value: "Neonatology", label: "Neonatology" },
  { value: "Psychiatry", label: "Psychiatry" },
  { value: "Dermatology", label: "Dermatology" },
  { value: "Radiology", label: "Radiology" },
  {
    value: "General Anesthesiology",
    label: "General Anesthesiology",
  },
  { value: "Neurology", label: "Neurology" },
  { value: "Ophthalmology", label: "Ophthalmology" },
  { value: "Pathology", label: "Pathology" },
  {
    value: "Family Medicine (GP)",
    label: "Family Medicine (GP)",
  },
  { value: "No Specialty", label: "No Specialty" },
];

export const yearsofExperience = [
  { value: "0 - 2", label: "0 - 2 years" },
  { value: "3 - 5", label: "3 - 5 years" },
  { value: "5 - 10", label: "5 - 10 years" },
  { value: "11", label: "11 years above" },
];

export const jobTitle = [
  { value: "", label: "Select a title" },
  { value: "Doctor", label: "Doctor" },
  { value: "Nurse", label: "Nurse" },
  { value: "Midwife", label: "Midwife" },
  { value: "Nurse/Midwife", label: "Nurse/Midwife" },
];

export const qualificationData = [
  { value: "MBBS", label: "MBBS" },
  { value: "MBCHB", label: "MBCHB" },
  {
    value: "Fellowship",
    label: "Fellowship",
  },
  
   
  {
    value: "Others",
    label: "Others",
  },
];

export const nurseQualificationData = [
  
  {
    value: "Registered Nurse (RN)",
    label: "Registered Nurse (RN)",
  },
  {
    value: "Registered Midwife (RM)",
    label: "Registered Midwife (RM)",
  },
  {
    value: "BSc Nursing",
    label: "BSc Nursing",
  },
  {
    value: "Certified nurse midwife (CNM)",
    label: "Certified nurse midwife (CNM)",
  }
];

export const experienceLevel = [
  {
    value: "0-3",
    label: "0-3",
  },
  {
    value: "4-6",
    label: "4-6",
  },
  {
    value: "6-10",
    label: "6-10",
  },
  {
    value: "10-15",
    label: "10-15",
  },
  {
    value: "15+",
    label: "15+",
  },
  {
    value: "Resident",
    label: "Resident",
  },
];
